import { render, staticRenderFns } from "./DataCollectionStatsContainer.vue?vue&type=template&id=60cf5262&scoped=true"
import script from "./DataCollectionStatsContainer.vue?vue&type=script&lang=js"
export * from "./DataCollectionStatsContainer.vue?vue&type=script&lang=js"
import style0 from "./DataCollectionStatsContainer.vue?vue&type=style&index=0&id=60cf5262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf5262",
  null
  
)

export default component.exports